<script lang="ts">
  import LoadDefinition from '../../LoadDefinition.svelte';
</script>

<div class="p-3">
  <LoadDefinition />
</div>
